export default [
    {
        path: "/broker/manage",
        name: "broker-manage",
        component: () => import("@/views/broker/brokerManage/index.vue"),
        meta: {
            pageTitle: "经纪人管理",
            resource: 'broker-manage',
            action: 'index',
            breadcrumb: [
                {
                    text: "经纪招商",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/broker/customer",
        name: "broker-customer",
        component: () => import("@/views/broker/brokerCustomer/index.vue"),
        meta: {
            pageTitle: "经纪人客户",
            resource: 'broker-customer',
            action: 'index',
            breadcrumb: [
                {
                    text: "经纪招商",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/customer/appointment",
        name: "customer-appointment",
        component: () => import("@/views/broker/customerAppointment/index.vue"),
        meta: {
            pageTitle: "客户预约单",
            resource: 'broker-appointment',
            action: 'index',
            breadcrumb: [
                {
                    text: "经纪招商",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/recommend/customer",
        name: "recommend-customer",
        component: () => import("@/views/broker/recommendCustomer/index.vue"),
        meta: {
            pageTitle: "推介客户单",
            resource: 'broker-recommend',
            action: 'index',
            breadcrumb: [
                {
                    text: "经纪招商",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/customer/confirm",
        name: "customer-confirm",
        component: () => import("@/views/broker/customerConfirm/index.vue"),
        meta: {
            pageTitle: "客户确认书",
            resource: 'broker-confirm',
            action: 'index',
            breadcrumb: [
                {
                    text: "经纪招商",
                    active: true,
                },
            ],
        },
    },
]
